import { X } from 'lucide-react';
import { modalStore } from '../../stores';
import { Modal } from '../elements';

import cherriesBox from '../../assets/images/kersendoos.jpg';
import styles from '../../assets/styles/fruitboxModal.module.scss';


const FruitboxInfo = () => {
  const { closeModal } = modalStore;

  const close = () => {
    closeModal('fruitbox_info');
  }

  return (
    <Modal id="fruitbox_info">
      <div className="modal-header">
        <h1>
          Uitleg fruitbox
        </h1>
        <X onClick={close} />
      </div>
      <div className="modal-content">
        Met Engelendael hebben we volop ingezet op <strong>ecologie</strong>.<br />
        Dit zie je terug in onze vernieuwde gepersonaliseerde kartonnen kersenverpakking.
        <br /><br />
        Een fruitbox is een vervangproduct van de plastieken zak die een <strong>herbruikbare stevige doos</strong> is om  kersenverpakkingen of andere goederen in te vervoeren.
        <br /><br />

        In de fruitbox passen 6 kersendozen van 1 kg.
        <br /><br />

        De kostprijs van deze doos bedraagt slechts 1 euro.

        <div className={styles.imgContainer}>
          <img src={cherriesBox} alt="Kersen doos" />
        </div>

      </div>
    </Modal>
  )
};

export default FruitboxInfo;
